<svg
	xmlns="http://www.w3.org/2000/svg"
	width="24px"
	height="24px"
	fill="currentColor"
	stroke-width="1.5"
	viewBox="0 0 24 24"
	color="currentColor"
	><path
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
		d="M21.044 5.704a.6.6 0 0 1 .956.483v11.626a.6.6 0 0 1-.956.483l-7.889-5.813a.6.6 0 0 1 0-.966l7.89-5.813ZM10.044 5.704a.6.6 0 0 1 .956.483v11.626a.6.6 0 0 1-.956.483l-7.888-5.813a.6.6 0 0 1 0-.966l7.888-5.813Z"
	/></svg
>
